import { render, staticRenderFns } from "./SlidBar.vue?vue&type=template&id=6ce98430&scoped=true"
import script from "./SlidBar.vue?vue&type=script&lang=js"
export * from "./SlidBar.vue?vue&type=script&lang=js"
import style0 from "./SlidBar.vue?vue&type=style&index=0&id=6ce98430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce98430",
  null
  
)

export default component.exports